import { jsx as _jsx } from "react/jsx-runtime";
const Link = ({ as: Component = 'a', children, className = '', color, 'data-testid': dataTestId, display = 'initial', onClick, padding, target, to = '', underline, }) => {
    const classes = [
        'link',
        underline ? 'link-underline' : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    const style = {
        display,
    };
    if (color)
        style.color = color;
    if (padding)
        style.padding = padding;
    // If it's an external link (starts with http:// or https://)
    if (to && /^https?:\/\//.test(to)) {
        return (_jsx("a", { className: classes, "data-testid": dataTestId, href: to, onClick: onClick, style: style, target: target, children: children }));
    }
    // For internal links or custom components
    return (_jsx(Component, { className: classes, "data-testid": dataTestId, onClick: onClick, style: style, to: to, children: children }));
};
export default Link;
//# sourceMappingURL=link.js.map